<template>
  <div class="body">
    <TopNav></TopNav>
    <div class="contact-wrap">
      <div class="banner">
        <div class="title">联系我们</div>
        <div class="sub">CONTACT US</div>
      </div>
      <div class="list">
        <div class="top">
          <div class="left-wrap">
            <img src="../assets/images/contact/top.png" alt="" />
          </div>
          <div class="right-wrap">
            <div class="name">OneCust 1号定制</div>
            <div class="desc">
              1号定制是隶属于厦门壹号云数科技有限公司；平台由全国顶尖的技术研发团队根据跨境电商DIY定制铺货模式量身开发。
              1号定制提供一站式跨境电商DIY定制铺货服务，从供应链—设计定制—铺货上架—下单生产—质检发货全面提供尽善尽美的服务。同时，
              1号定制大大简化了跨境电商卖家定制铺货工作，使工作效率飞跃提升；轻松日铺千款SKU。
              1号定制不单单是一个平台，还在持续努力构建一个健康且开放分享的跨境定制铺货生态。
              1号定制是一个开放式的定制选品平台，满足您关于DIY定制、定制铺货的所想所需。
            </div>
          </div>
        </div>
      </div>
      <div class="tip">
        <div class="title">公司动态头条</div>
        <div class="sub-title">行业动态全掌控</div>
      </div>
      <div class="contact-list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="image">
            <img :src="item.image" />
          </div>
          <div class="name" :title="item.name">{{ item.name }}</div>
          <div class="desc" :title="item.desc">
            {{ item.desc }}
          </div>
        </div>
      </div>
      <div style="height: 360px" class="map">
        <div v-if="false" class="top" id="container"></div>
        <div class="bottom">
          <div class="title">1号定制总部</div>
          <div v-if="false" class="line">地址：荔城区凯天国际3号楼24层</div>
          <div class="line">营业时间：每天09:00-12:00，14:00-18:00</div>
          <div class="line">联系电话：135 5939 7618</div>
          <div class="line">联系客服：service@onecust.com</div>
          <div class="line">商务合作：bd@onecust.com</div>
          <div class="line">技术支持：support@onecust.com</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Feedback></Feedback>
  </div>
</template>

<script>
import TopNav from "./default/TopNav";
import Footer from "./default/Footer";
import image0 from "@/assets/images/contact/image-0.png";
import image1 from "@/assets/images/contact/image-1.png";
import image2 from "@/assets/images/contact/image-2.png";
import image3 from "@/assets/images/contact/image-3.png";
import Feedback from "./default1/Feedback"
export default {
  components: {
    TopNav,
    Footer,
    Feedback
  },
  data() {
    return {
      list: [
        {
          image: image0,
          name: "对外开放运营，所有类品全开",
          desc: "产品矩阵覆盖全品类，主打鞋类产品，可适用亚马逊、自建站、wish、etsy，淘宝\天猫等各种国内外渠道。",
        },
        {
          image: image1,
          name: "刺绣工艺，重磅首推",
          desc: "平台支持线上刺绣定制技术，实现一件起订，产品覆盖帽子、衣服、鞋子等多种类品",
        },
        {
          image: image2,
          name: "春夏款持续上新，自主研发",
          desc: "鞋款覆盖全用途与多年龄层消费群体，每年新品爆款上新逾100+。",
        },
        {
          image: image3,
          name: "日均产能突破10w件",
          desc: "全资控股供应链与智能化流水线，产能实现现象级突破，完全具备应对销售高峰期的生产能力。",
        },
      ],
    };
  },
  mounted() {
    this.getMap();
  },
  methods: {
    getMap() {
      var map = new BMapGL.Map("container");
      // 创建地图实例
      var point = new BMapGL.Point(119.041538, 25.438527);
      // 创建标注
      var marker = new BMapGL.Marker(point);
      var label = new BMapGL.Label("1号定制总店", {
        // 创建文本标注
        position: point, // 设置标注的地理位置
        offset: new BMapGL.Size(-20, 10), // 设置标注的偏移量
      });

      map.addOverlay(label); // 将标注添加到地图中
      map.addOverlay(marker);
      // 创建点坐标
      map.centerAndZoom(point, 15);
    },
  },
};
</script>

<style>
@import "../assets/css/default/top-nav.css";
@import "../assets/css/default/main.css";
</style>

<style lang="scss" scoped>
.contact-wrap {
  .banner {
    width: 100%;
    height: 430px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: url("../assets/images/contact/banner.png") no-repeat;
    background-size: cover;

    .title {
      font-size: 48px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      line-height: 38px;
      margin-bottom: 20px;
    }

    .sub {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 38px;
    }
  }
}

.list {
  width: 1200px;
  margin: -50px auto 20px;

  .top {
    height: 400px;
    display: flex;
    justify-content: space-between;

    .left-wrap {
      width: 580px;
      height: 400px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right-wrap {
      width: 590px;

      .name {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin: 80px auto 30px;
      }

      .desc {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        text-align: left;
      }
    }
  }
}

.tip {
  margin: 90px auto 30px;
  width: 100%;
  text-align: center;

  .title {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #181b1c;
    margin-bottom: 10px;
  }

  .sub-title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }
}

.contact-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  margin: 60px auto 30px;

  .item {
    width: 270px;
    height: 330px;
    background: #ffffff;
    border: 1px solid #e9e9e9;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.3s linear;

    &:hover {
      box-shadow: 0 0px 13px 0 rgb(64 147 243 / 35%);
      transform: translateY(-10px);
    }

    .image {
      width: 270px;
      height: 200px;
      margin-bottom: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .name {
      width: 85%;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #181b1c;
      margin: 0 auto 20px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .desc {
      width: 85%;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin: 0 auto;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}

.map {
  width: 1200px;
  height: 767px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  margin: 60px auto;

  .top {
    width: 1200px;
    height: 400px;
  }

  .bottom {
    .title {
      height: 32px;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #181b1c;
      width: 80%;
      margin: 40px auto;
      text-align: left;
    }

    .line {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #181b1c;
      width: 80%;
      line-height: 30px;
      margin: 10px auto;
    }
  }
}
</style>
